<div class="mt-3">
    <h5 class="ap-green">{{header1}}</h5>
    <div><label style="color: red">{{header2}}</label></div>
    <div>
        <dx-data-grid #totalPotentialLOXLINVolumeGrid style="width: 100%" [dataSource]="demandByDistances[0]"
            [columnAutoWidth]="true" [allowColumnReordering]="true" [wordWrapEnabled]="false" showBorders="true">
            <dxo-toolbar>
                <dxi-item name="groupPanel"></dxi-item>
                <dxi-item location="after">
                    <dx-button icon="exportxlsx" class="ap-blue-btn"
                        (onClick)="exportExcel_TotalPotentialLOXLINVolume($event)" text="Export to Excel">
                    </dx-button>
                </dxi-item>
                <dxi-item name="searchPanel"></dxi-item>
            </dxo-toolbar>
            <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
            <dxo-header-filter [visible]="true"></dxo-header-filter>
            <dxo-search-panel [visible]="true"></dxo-search-panel>
            <dxo-paging [pageSize]="10"></dxo-paging>
            <dxo-sorting mode="multiple"></dxo-sorting>
            <dxo-export [enabled]="true"></dxo-export>
            <dxi-column dataField="plantSiteName" cssClass="column-group-sub-header" caption="Plant Site Name"
                [groupIndex]="0"></dxi-column>
            <dxi-column dataField="distance" cssClass="column-group-sub-header"
                caption="Miles from customer"></dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="dis100"
                caption="100 mi 161 km unfav">
                <dxo-format type="fixedPoint"></dxo-format> 
            </dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="dis50" caption="50 mi 80 km unfav">
                <dxo-format type="fixedPoint"></dxo-format>
            </dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="dis30" caption="30 mi 48 km unfav">
                <dxo-format type="fixedPoint"></dxo-format>
            </dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="even" caption="Even">
                <dxo-format type="fixedPoint"></dxo-format>
            </dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="adv30" caption="30 mi  48 km fav">
                <dxo-format type="fixedPoint"></dxo-format>
            </dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="adv50" caption="50 mi  80 km fav">
                <dxo-format type="fixedPoint"></dxo-format>
            </dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="adv100" caption="100 mi  161 km fav">
                <dxo-format type="fixedPoint"></dxo-format>
            </dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="total" caption="total">
                <dxo-format type="fixedPoint"></dxo-format>
            </dxi-column>
            <dxo-summary>
                <dxi-group-item column="dis100" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint'}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="dis50" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint'}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="dis30" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint'}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="even" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint'}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="adv30" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint'}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="adv50" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint'}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="mtDnetO2" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint'}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="adv100" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint'}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="total" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint'}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint"></dxo-format>
                </dxi-group-item>
            </dxo-summary>
        </dx-data-grid>

        <br>
        <h6 class="ap-green mt-3">{{header3}}</h6>
        <div class="">{{header4}}</div>
        <dx-data-grid #potentialLOXLINVolumeGrid style="width: 100%" [dataSource]="demandByDistances[1]"
            [columnAutoWidth]="true" [allowColumnReordering]="true" [wordWrapEnabled]="false" showBorders="true">
            <dxo-toolbar>
                <dxi-item name="groupPanel"></dxi-item>
                <dxi-item location="after">
                    <dx-button icon="exportxlsx" class="ap-blue-btn"
                        (onClick)="exportExcel_PotentialLOXLINVolume($event)" text="Export to Excel">
                    </dx-button>
                </dxi-item>
                <dxi-item name="searchPanel"></dxi-item>
            </dxo-toolbar>
            <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
            <dxo-header-filter [visible]="true"></dxo-header-filter>
            <dxo-search-panel [visible]="true"></dxo-search-panel>
            <dxo-paging [pageSize]="10"></dxo-paging>
            <dxo-sorting mode="multiple"></dxo-sorting>
            <dxo-export [enabled]="true"></dxo-export>
            <dxi-column dataField="plantSiteName" cssClass="column-group-sub-header" caption="Plant Site Name"
                [groupIndex]="0"></dxi-column>
            <dxi-column dataField="distance" cssClass="column-group-sub-header"
                caption="Miles from customer"></dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="dis100"
                caption="100 mi 161 km unfav">
                <dxo-format type="fixedPoint"></dxo-format>
            </dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="dis50" caption="50 mi 80 km unfav">
                <dxo-format type="fixedPoint"></dxo-format>
            </dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="dis30" caption="30 mi 48 km unfav">
                <dxo-format type="fixedPoint"></dxo-format>
            </dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="even" caption="Even">
                <dxo-format type="fixedPoint"></dxo-format>
            </dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="adv30" caption="30 mi  48 km fav">
                <dxo-format type="fixedPoint"></dxo-format>
            </dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="adv50" caption="50 mi  80 km fav">
                <dxo-format type="fixedPoint"></dxo-format>
            </dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="adv100" caption="100 mi  161 km fav">
                <dxo-format type="fixedPoint"></dxo-format>
            </dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="total" caption="total">
                <dxo-format type="fixedPoint"></dxo-format>
            </dxi-column>
            <dxo-summary>
                <dxi-group-item column="dis100" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint',precision:0}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="0"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="dis50" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint',precision:0}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="0"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="dis30" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint'}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="even" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint',precision:0}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="0"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="adv30" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint',precision:0}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="0"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="adv50" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint',precision:0}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="0"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="mtDnetO2" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint',precision:0}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="0"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="adv100" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint',precision:0}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="0"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="total" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                [valueFormat]="{type:'fixedPoint',precision:0}" [alignByColumn]="true">
                <dxo-format type="fixedPoint" [precision]="0"></dxo-format>
            </dxi-group-item>
            </dxo-summary>
        </dx-data-grid>

        <br>
        <h6 class="ap-green mt-3">{{header5}}</h6>
        <dx-data-grid #totalPotentialLOXLINVolumeNonAPGrid style="width: 100%" [dataSource]="demandByDistances[2]"
            [columnAutoWidth]="true" [allowColumnReordering]="true" [wordWrapEnabled]="false" showBorders="true">
            <dxo-toolbar>
                <dxi-item name="groupPanel"></dxi-item>
                <dxi-item location="after">
                    <dx-button icon="exportxlsx" class="ap-blue-btn"
                        (onClick)="exportExcel_TotalPotentialLOXLINVolumeNonAP($event)" text="Export to Excel">
                    </dx-button>
                </dxi-item>
                <dxi-item name="searchPanel"></dxi-item>
            </dxo-toolbar>
            <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
            <dxo-header-filter [visible]="true"></dxo-header-filter>
            <dxo-search-panel [visible]="true"></dxo-search-panel>
            <dxo-paging [pageSize]="10"></dxo-paging>
            <dxo-sorting mode="multiple"></dxo-sorting>
            <dxo-export [enabled]="true"></dxo-export>
            <dxi-column dataField="plantSiteName" cssClass="column-group-sub-header" caption="Plant Site Name"
                [groupIndex]="0"></dxi-column>
            <dxi-column dataField="distance" cssClass="column-group-sub-header"
                caption="Miles from customer"></dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="dis100NoAP"
                caption="100 mi 161 km unfav">
                <dxo-format type="fixedPoint"></dxo-format>
            </dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="dis50NoAP" caption="50 mi 80 km unfav">
                <dxo-format type="fixedPoint"></dxo-format>
            </dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="dis30NoAP" caption="30 mi 48 km unfav">
                <dxo-format type="fixedPoint"></dxo-format>
            </dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="evenNoAP" caption="Even">
                <dxo-format type="fixedPoint"></dxo-format>
            </dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="adv30NoAP" caption="30 mi  48 km fav">
                <dxo-format type="fixedPoint"></dxo-format>
            </dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="adv50NoAP" caption="50 mi  80 km fav">
                <dxo-format type="fixedPoint"></dxo-format>
            </dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="adv100NoAP" caption="100 mi  161 km fav">
                <dxo-format type="fixedPoint"></dxo-format>
            </dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="totalNoAP" caption="totalNoAP">
                <dxo-format type="fixedPoint"></dxo-format>
            </dxi-column>
            <dxo-summary>
                <dxi-group-item column="dis100NoAP" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint',precision:0}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="0"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="dis50NoAP" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint',precision:0}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="0"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="dis30NoAP" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint'}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="evenNoAP" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint',precision:0}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="0"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="adv30NoAP" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint',precision:0}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="0"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="adv50NoAP" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint',precision:0}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="0"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="mtDnetO2" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint',precision:0}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="0"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="adv100NoAP" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint',precision:0}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="0"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="totalNoAP" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                [valueFormat]="{type:'fixedPoint',precision:0}" [alignByColumn]="true">
                <dxo-format type="fixedPoint" [precision]="0"></dxo-format>
            </dxi-group-item>
            </dxo-summary>
        </dx-data-grid>

        <br>
        <h6 class="ap-green mt-3">{{header6}}</h6>
        <dx-data-grid #potentialLOXLINVolumeNonAPGrid style="width: 100%" [dataSource]="demandByDistances[3]"
            [columnAutoWidth]="true" [allowColumnReordering]="true" [wordWrapEnabled]="false" showBorders="true">
            <dxo-toolbar>
                <dxi-item name="groupPanel"></dxi-item>
                <dxi-item location="after">
                    <dx-button icon="exportxlsx" class="ap-blue-btn"
                        (onClick)="exportExcel_PotentialLOXLINVolumeNonAP($event)" text="Export to Excel">
                    </dx-button>
                </dxi-item>
                <dxi-item name="searchPanel"></dxi-item>
            </dxo-toolbar>
            <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
            <dxo-header-filter [visible]="true"></dxo-header-filter>
            <dxo-search-panel [visible]="true"></dxo-search-panel>
            <dxo-paging [pageSize]="10"></dxo-paging>
            <dxo-sorting mode="multiple"></dxo-sorting>
            <dxo-export [enabled]="true"></dxo-export>
            <dxi-column dataField="plantSiteName" cssClass="column-group-sub-header" caption="Plant Site Name"
                [groupIndex]="0"></dxi-column>
            <dxi-column dataField="distance" cssClass="column-group-sub-header"
                caption="Miles from customer"></dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="dis100NoAP"
                caption="100 mi 161 km unfav">
                <dxo-format type="fixedPoint"></dxo-format>
            </dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="dis50NoAP" caption="50 mi 80 km unfav">
                <dxo-format type="fixedPoint"></dxo-format>
            </dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="dis30NoAP" caption="30 mi 48 km unfav">
                <dxo-format type="fixedPoint"></dxo-format>
            </dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="evenNoAP" caption="Even">
                <dxo-format type="fixedPoint"></dxo-format>
            </dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="adv30NoAP" caption="30 mi  48 km fav">
                <dxo-format type="fixedPoint"></dxo-format>
            </dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="adv50NoAP" caption="50 mi  80 km fav">
                <dxo-format type="fixedPoint"></dxo-format>
            </dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="adv100NoAP" caption="100 mi  161 km fav">
                <dxo-format type="fixedPoint"></dxo-format>
            </dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="totalNoAP" caption="totalNoAP">
                <dxo-format type="fixedPoint"></dxo-format>
            </dxi-column>
            <dxo-summary>
                <dxi-group-item column="dis100NoAP" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint',precision:0}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="0"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="dis50NoAP" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint',precision:0}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="0"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="dis30NoAP" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint'}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="evenNoAP" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint',precision:0}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="0"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="adv30NoAP" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint',precision:0}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="0"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="adv50NoAP" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint',precision:0}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="0"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="mtDnetO2" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint',precision:0}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="0"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="adv100NoAP" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint',precision:0}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="0"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="totalNoAP" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                [valueFormat]="{type:'fixedPoint',precision:0}" [alignByColumn]="true">
                <dxo-format type="fixedPoint" [precision]="0"></dxo-format>
            </dxi-group-item>
            </dxo-summary>
        </dx-data-grid>
    </div>
</div>